import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { getPublicProposal, quotePublicProposal, submitPublicProposal } from '@/api/proposals';
import ProposalView from '@/components/proposals/ProposalView';

// A client's private proposal link: pick the Optional services before the agreement. No login; the token is the key.
export default function ProposalPublicPage() {
  const { token } = useParams();
  const api = useMemo(() => ({
    load: () => getPublicProposal(token),
    quote: (chosen) => quotePublicProposal(token, chosen),
    submit: (body) => submitPublicProposal(token, body),
  }), [token]);
  return <ProposalView key={token} api={api} />;
}
